import { StudentReviewCtrl } from './student-review.controller';

export const StudentReviewComponent = {
  controller: StudentReviewCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./student-review.html'),
};
